export default __webpack_public_path__ + "static/media/Etelä-Saimaa.0e8984a7.svg";